const state = {
	openBar: false,
	authItems: [],
	account: {},
	stripePubKey: ''
}

const mutations = {
	openBar (state, value) {
		state.openBar = value
	},
	authItems (state, items) {
		state.authItems = items
	},
	account (state, value) {
		state.account = value
	},
	stripePubKey (state, value) {
		state.stripePubKey = value
	}
}

const getters = {

}

const actions = {

}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js